// تبدیل میلادی به شمسی
export function gregorianToJalali(gy: number, gm: number, gd: number) {
    const g_d_m = [0,31,59,90,120,151,181,212,243,273,304,334];
    let jy = (gy <= 1600) ? 0 : 979;
    gy -= (gy <= 1600) ? 621 : 1600;
    const gy2 = (gm > 2) ? (gy + 1) : gy;
    let days = (365 * gy) + ((gy2 + 3) / 4 | 0) - ((gy2 + 99) / 100 | 0) + ((gy2 + 399) / 400 | 0) - 80 + gd + g_d_m[gm-1];
    jy += 33 * (days / 12053 | 0);
    days %= 12053;
    jy += 4 * (days / 1461 | 0);
    days %= 1461;
    if (days > 365) {
      jy += (days - 1) / 365 | 0;
      days = (days - 1) % 365;
    }
    const jm = (days < 186) ? 1 + (days / 31 | 0) : 7 + ((days - 186) / 30 | 0);
    const jd = 1 + ((days < 186) ? (days % 31) : ((days - 186) % 30));
    return { jy, jm, jd };
  }
  
  // تبدیل شمسی به میلادی
  export function jalaliToGregorian(jy: number, jm: number, jd: number) {
    jy += 1595;
    let days = -355668 + (365 * jy) + ((jy / 33) | 0) * 8 + (((jy % 33) + 3) / 4) | 0;
    for (let i = 1; i < jm; ++i) {
      days += i <= 6 ? 31 : (i <= 11 ? 30 : 29);
    }
    days += jd;
    let gy = 400 * (days / 146097 | 0);
    days %= 146097;
    if (days > 36524) {
      gy += 100 * (--days / 36524 | 0);
      days %= 36524;
      if (days >= 365) ++days;
    }
    gy += 4 * (days / 1461 | 0);
    days %= 1461;
    if (days > 365) {
      gy += (days - 1) / 365 | 0;
      days = (days - 1) % 365;
    }
    let gd = days + 1;
    const sal_a = [0,31,((gy % 4 === 0 && gy % 100 !== 0) || (gy % 400 === 0)) ? 29 : 28,31,30,31,30,31,31,30,31,30,31];
    let gm;
    for (gm = 1; gm < 13; gm++) {
      if (gd <= sal_a[gm]) break;
      gd -= sal_a[gm];
    }
    return { gy, gm, gd };
  }
  